import { Globe2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { usePermission } from '@/hooks/use-permission';
import { formatDateTime } from '@/lib/format';
import { useRecordVisits } from './api';

/** The website pages a lead or contact looked at, from the tracking snippet. */
export function WebsiteVisitsCard({ entityType, entityId }: { entityType: 'lead' | 'contact'; entityId: string }) {
  const { can } = usePermission();
  const { data } = useRecordVisits(entityType, entityId, can(`crm.${entityType}.view`));
  if (!data?.views.length) return null;
  const first = data.visitors[0];
  const source = first?.firstUtm?.source ? `${first.firstUtm.source}${first.firstUtm.campaign ? ` / ${first.firstUtm.campaign}` : ''}` : first?.firstReferrer ? new URL(first.firstReferrer).hostname : 'direct';
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <Globe2 className="h-4 w-4" /> Website visits
        </CardTitle>
        <p className="text-xs text-muted-foreground">
          First came from {source} · {data.views.length} pages
        </p>
      </CardHeader>
      <CardContent>
        <ul className="space-y-2">
          {data.views.slice(0, 12).map((view) => (
            <li key={view.id} className="text-sm">
              <a href={view.url} target="_blank" rel="noreferrer" className="block truncate font-medium hover:underline">
                {view.title || view.path}
              </a>
              <span className="text-xs text-muted-foreground">{formatDateTime(view.createdAt)}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
